import React from 'react';
import c from '../w.js';

const IconArrowUpRight = React.memo(
  c(
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00001 5H19V16H17V8.41421L6.70712 18.7071L5.29291 17.2929L15.5858 7H8.00001V5Z"
      }
    )
  )
);

export { IconArrowUpRight };
